import { CollaborationResult } from '@descomplica/microfrontend-core';
import { ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type {
  ApplicationDto,
  IPegasusIOGateway,
} from '@/shared/application/interfaces/pegasus-io.gateway';

export const APPLICATION_REMOVED = 'ApplicationRemoved';
export const SCOPE_REMOVED = 'ScopeDeleted';

type RemoveApplicationInput = {
  guid: string;
  scopeGuid: string;
};

@injectable()
export class RemoveApplicationCollaboration
  implements ICollaboration<RemoveApplicationInput, CollaborationResult<ApplicationDto>>
{
  constructor(
    @inject('IPegasusIOGateway')
    private readonly pegasusIOGateway: IPegasusIOGateway,
  ) {}

  public async run({ guid, scopeGuid }) {
    return await this.pegasusIOGateway.removeApplication(guid, scopeGuid);
  }
}
